"use client";

import { AuthImg } from "./ArtifactCanvas";
import type { ArtifactSelectionItem } from "@/lib/artifactSelection";

export function RecentArtifactThumbnail({ item }: { item: ArtifactSelectionItem }) {
  const base = "flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-md border border-gray-200 bg-gray-100 dark:border-[#3a3a3e] dark:bg-[#2a2a2e]";

  if (item.kind === "file" && item.mimeType.startsWith("image/")) {
    return (
      <div className={base}>
        <AuthImg fileId={item.fileId} className="h-full w-full object-cover" alt={item.title} />
      </div>
    );
  }

  let emoji = "📎";
  if (item.kind === "artifact") {
    emoji = item.type === "risk_assessment" ? "📊"
      : item.type === "tbm_scenario" ? "🦺"
        : item.type === "tbm_record" ? "📋"
      : item.type === "cost_estimate" || item.type === "cost_estimate_material_change" ? "🧮"
        : item.type === "cases" ? "🔍"
          : item.type === "laws" ? "⚖️"
            : "📝";
  } else if (item.mimeType === "application/pdf") {
    emoji = "📕";
  } else if (item.mimeType.includes("spreadsheet") || item.mimeType.includes("excel")) {
    emoji = "📊";
  } else if (item.mimeType.includes("word") || item.mimeType.includes("document") || item.mimeType.includes("hwp")) {
    emoji = "📄";
  }

  return <div className={`${base} text-base`}>{emoji}</div>;
}
